import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-savings-modal',
  templateUrl: './savings-modal.component.html',
  styleUrls: ['./savings-modal.component.scss']
})
export class SavingsModalComponent {
  @Input() savingsAmount: number = 600;
  @Input() currency: string = '₹';
  @Output() continue = new EventEmitter<void>();

  constructor(private modalController: ModalController) {}

  onContinue() {
    this.continue.emit();
    this.dismiss(true);
  }

  onOutsideClick(event: Event) {
    // Close the modal when clicking outside the modal content
    this.dismiss(false);
  }

  dismiss(continueAction: boolean = false) {
    this.modalController.dismiss({
      continue: continueAction,
      savingsAmount: this.savingsAmount
    });
  }
}
